"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperprepAssetUtil = void 0;
/* eslint-disable require-jsdoc */
const types_1 = require("../main/types");
const LanguageAVAsset_1 = require("./LanguageAVAsset");
const SuperprepAsset_1 = require("./SuperprepAsset");
const ImageAsset_1 = require("./ImageAsset");
const IconAsset_1 = require("./IconAsset");
const DiagramAsset_1 = require("./DiagramAsset");
class SuperprepAssetUtil {
    static getConverter(type) {
        switch (type) {
            case types_1.AssetType.Audio:
            case types_1.AssetType.Video:
                return LanguageAVAsset_1.LanguageAVAsset.converter;
            case types_1.AssetType.Image:
                return ImageAsset_1.ImageAsset.converter;
            case types_1.AssetType.Icon:
                return IconAsset_1.IconAsset.converter;
            case types_1.AssetType.Diagram:
                return DiagramAsset_1.DiagramAsset.converter;
            default:
                return SuperprepAsset_1.SuperprepAsset.converter;
        }
    }
    static getAlgoliaConverterFunc(type) {
        switch (type) {
            case types_1.AssetType.Audio:
            case types_1.AssetType.Video:
                return LanguageAVAsset_1.LanguageAVAsset.fromAlgolia;
            case types_1.AssetType.Image:
                return ImageAsset_1.ImageAsset.fromAlgolia;
            case types_1.AssetType.Icon:
                return IconAsset_1.IconAsset.fromAlgolia;
            case types_1.AssetType.Diagram:
                return DiagramAsset_1.DiagramAsset.fromAlgolia;
            default:
                return SuperprepAsset_1.SuperprepAsset.fromAlgolia;
        }
    }
}
exports.SuperprepAssetUtil = SuperprepAssetUtil;
